import { ReactElement } from 'react';

// ローディング表示
function Loading(): ReactElement {
  const text = 'Kotomil';
  
  return (
    <div className="flex justify-center items-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
      <div className="flex space-x-1 text-4xl md:text-5xl font-extrabold tracking-wider">
        {text.split('').map((char, index) => (
          <span
            key={index}
            className="animate-bounce bg-gradient-to-b from-kotomilThemaColorLight to-kotomilThemaColor bg-clip-text text-transparent"
            style={{ animationDelay: `${index * 100}ms` }}
          >
            {char}
          </span>
        ))}
      </div>
    </div>
  );
}

export default Loading;
